import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios"
import api from './api/index.js'
import * as echarts from 'echarts'
import '@/assets/font/font.css'

Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios
Vue.prototype.$store = store


Vue.config.productionTip = false
Vue.prototype.$api = api

Vue.use(ElementUI);
Vue.use(VueRouter)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
